import { createElement, Component, Props as ReactProps } from 'react';
import { DependencyProps } from '../../../../core/dependency';
import { LocationProps } from '../../../../core/location';
import { StateProps } from '../../../../core/state';
import RootFrame from '../../../components/templates/RootFrame';
import {
  Modal,
  Button,
} from "antd";

type Props = ReactProps<HTMLDivElement> &
  DependencyProps &
  StateProps &
  LocationProps & {
    attrs?: any;
  };

class ShipMethodButtonRoute extends Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.change = this.change.bind(this);
  }

  public componentWillMount() {
    this.initialize(this.props);
  }

  public componentWillUnmount() {
    this.dispose(this.props);
  }

  public render() {
    const { dependency, location, state } = this.props;
    const {
      fetches,
    } = state.payment;
    const currentStore = state.currentStore;
    if (!currentStore) {
      return null;
    }
    const title = this.props.attrs && this.props.attrs.title && this.props.attrs.title.nodeValue || 'NoName';
    const shipMethod = this.props.attrs && this.props.attrs.method && this.props.attrs.method.nodeValue || 'delivery';
    if (!(shipMethod === 'shop' || shipMethod === 'delivery')) {
      return null;
    }

    const summaries = <Button
      onClick={() => this.change(shipMethod)}
    >
      {title}
    </Button>;

    return <RootFrame
      {...{ dependency, location, state }}
      content={summaries}
      isSpinner={fetches === 1}
    />;
  }

  private async initialize(props: Props) {
    try {
      await props.dependency.payment.initialize();
    } catch (err) {
      window.console.error(err);
    }
  }

  private async change(shipMethod: string) {
    try {
      await this.props.dependency.payment.saveShipMethod(shipMethod);
      if (this.props.attrs && this.props.attrs.href) {
        window.location.href = this.props.attrs.href.nodeValue;
      }
    } catch (e) {
      Modal.error({
        title: '変更に失敗',
        content: <div>
          <div>保存に失敗しました。</div>
          <div>{e.message}</div>
        </div>,
      });
    }
  }

  private dispose(props: Props) {
    try {
      props.dependency.payment.dispose();
    } catch (err) {
      window.console.error(err);
    }
  }
}

export default ShipMethodButtonRoute;
